import React, { useState } from "react";
import Button from "./Button";
import ProgressBar from "./ProgressBar";
import VerificationCode from "./VerificationCode";
import { useStateContext } from "../contexts/ContextProvider";
import { apiVerifyCurrentEmail } from "../services/apiService";

const initialErrorState = {
  email: "",
};

const ChangeEmailModal = () => {
  const { user, setUser, handleModal } = useStateContext();
  const [newEmail, setNewEmail] = useState("");
  const [error, setError] = useState(initialErrorState);
  const [page, setPage] = useState(1);
  const pages = 5;

  const nextPage = async () => {
    if (hasErrors()) {
      return;
    } else {
      setPage(page + 1);
    }
  };

  // const prevPage = () => {
  //   setPage(page - 1);
  // };

  const handleChange = (event) => {
    const { value } = event.target;
    setNewEmail(value);
  };

  const handleSave = async () => {
    if (hasErrors()) {
      return;
    } else {
      setUser((prevState) => ({
        ...prevState,
        email: newEmail.toLowerCase(),
      }));
    }
  };

  const sendVerification = async () => {
    const response = await apiVerifyCurrentEmail({
      email: user.email,
      newEmail,
    });
    if (response.hasError) {
      console.log("Error");
    } else {
      console.log(response.data.message);
      nextPage();
    }
  };

  const hasErrors = () => {
    const reg = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/); // valid email format?
    if (page === 3 && (newEmail === "" || !reg.test(newEmail))) {
      activateError("email");
      return true;
    } else {
      return false;
    }
  };

  const activateError = (item) => {
    setError((prevState) => ({
      ...prevState,
      [item]: "animate-shake text-red-600 border-red-600",
    }));
    setTimeout(() => {
      setError((prevState) => ({
        ...prevState,
        [item]: "",
      }));
    }, 500);
    clearTimeout();
  };

  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      <ProgressBar pages={pages} currentPage={page} />
      {page === 1 && (
        <div className="flex justify-center text-center mt-20 px-10">
          <div className="border-gray-500 border-2 rounded-3xl bg-gray-300 p-5">
            <p>We'll send a security code to your current email address.</p>
            <p className="mt-5">Click "Next" to proceed.</p>
          </div>
        </div>
      )}

      {page === 2 && (
        <VerificationCode
          type="confirm-email"
          email={user.email}
          newEmail={newEmail}
          customFunc={nextPage}
        />
      )}

      {page === 3 && (
        <>
          <div className={`flex justify-center mt-10 ${error.email}`}>
            Please select you new email address.
          </div>
          <div className="flex justify-center mt-5">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                sendVerification();
              }}
            >
              <label>
                <input
                  id="new-email"
                  name="newEmail"
                  type="email"
                  placeholder="New Email Address"
                  value={newEmail}
                  autoFocus={true}
                  autoComplete="email"
                  className={`border-gray-300 border-1 rounded-md
                 outline-snappily-orange ml-2 pl-1 ${error.email}`}
                  onChange={handleChange}
                />
              </label>
            </form>
          </div>
        </>
      )}
      {page === 4 && (
        <VerificationCode
          type="change-email"
          email={user.email}
          newEmail={newEmail}
          customFunc={() => {
            nextPage();
            handleSave();
          }}
        />
      )}
      {page === pages && (
        <div className="text-xl mt-10 p-10">
          <div className="flex justify-center text-center">
            Your email has been changed successfully to:
          </div>
          <div className="flex justify-center text-snappily-orange text-base mt-5">
            {user.email}
          </div>
        </div>
      )}

      <div className="flex justify-center fixed bottom-0 w-full mb-28">
        {page === 1 && (
          <Button
            background="bg-slate-400"
            text="text-white"
            opacity="bg-opacity-100"
            title="Cancel"
            height="h-10"
            width="w-24"
            borderColor="border-none"
            borderHover="hover:border-snappily-orange"
            customFunc={() => handleModal("changeEmail")}
          />
        )}
        {page !== 2 && page !== 4 && (
          <Button
            background="bg-snappily-orange"
            text="text-white"
            opacity="bg-opacity-100"
            title={page === pages ? "Done" : "Next"}
            height="h-10"
            width="w-24"
            borderColor="border-none"
            borderHover="hover:border-snappily-orange"
            customFunc={() => {
              if (page === 1) sendVerification();
              else if (page === 3) sendVerification();
              else if (page === pages) handleModal("changeEmail");
              else nextPage();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ChangeEmailModal;
